export default "__VITE_ASSET__$Kv1mtVt__"